//services__grid__slider

var servicesSlider = $('.services__grid__slider');

if(servicesSlider.length) {

    servicesSlider.each(function(index) {
        var slider = $(this);

        $(this).parent().siblings('.services__grid__slider__controls').find('.services__grid__slider__control--left').on('click', function(e) {
            let activeItems = slider.find('.js-anim--active');
            activeItems.removeClass('js-anim--active');
            slider.slick('slickPrev');

            // manually trigger scroll listeners
            dispatchEvent(new CustomEvent('scroll'));
        });

        $(this).parent().siblings('.services__grid__slider__controls').find('.services__grid__slider__control--right').on('click', function(e) {
            let activeItems = slider.find('.js-anim--active');
            activeItems.removeClass('js-anim--active');
            slider.slick('slickNext');

            // manually trigger scroll listeners
            dispatchEvent(new CustomEvent('scroll'));
        });

        slider.slick({
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            speed: 800,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: false,
            adaptiveHeight: true
        });
    });
}
